import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedPatients = (tenant, page = 1, search, rows = 10, enabled = true) => {

  return useQuery({
    queryKey: ["paginatedPatients", tenant, page, search, rows],
    enabled,
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        search.length < 3
          ? `${tenant}/patient/get`
          : `${tenant}/patient/search/page/${search.replace(/\//g, '-')}`,
        {
          params: {
            page,
            rows,
          },
        }
      );
      return response.data;
    },
  });
};
